module.exports = __webpack_public_path__ + "static/media/BrownTS_2017_BrownsGeneralizedVitalsEquation.e0fa387c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/manuscript/BrownTS_2017_BrownsGeneralizedVitalsEquation.pdf
// module id = 358
// module chunks = 0